import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-033f275c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "display-name-text" };
const _hoisted_2 = {
    key: 0,
    class: "campaign-state-indicator"
};
import { useCampaignSummary } from "src/shared/store/campaign-summary/composables";
import { useBuiltComponent, useComponentDisplayName, } from "src/shared/store/component-built/composables";
import { computed } from "vue";
import CampaignStatusPill from "../campaign/CampaignStatusPill.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentDisplayName',
    props: {
        componentId: {},
        tagName: { default: "span" }
    },
    setup(__props) {
        const props = __props;
        const { builtComponent } = useBuiltComponent(() => props.componentId);
        const { campaignSummary } = useCampaignSummary(() => { var _a; return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.campaign_id; });
        const isRootComponent = computed(() => {
            var _a;
            return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.isRoot();
        });
        const { displayName } = useComponentDisplayName(() => props.componentId);
        return (_ctx, _cache) => {
            return (_unref(builtComponent))
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tagName), {
                    key: 0,
                    class: "component-display-name-wrapper"
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(displayName)), 1 /* TEXT */),
                            (isRootComponent.value &&
                                ((_a = _unref(campaignSummary)) === null || _a === void 0 ? void 0 : _a.campaign_type) === 'MARKETING')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                    _createVNode(CampaignStatusPill, {
                                        state: _unref(campaignSummary).state
                                    }, null, 8 /* PROPS */, ["state"])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ];
                    }),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true);
        };
    }
});
